import { trim } from 'lodash';
import { getPreviousMatches, getRouteParams } from '../../common/router/router-selectors';
import { getLocation } from '../../common/store/location/location-selectors';
import { getCategories } from '../../common/selectors/categories-selectors';
import { navigateWithinForum } from '../../common/actions/navigate-within-forum';
import { isExperimentEnabled } from '../selectors/experiments-selectors';
import { UrlMappingsKeys } from '@wix/url-mapper-utils';
import {
  createFeedTypeQueryParam,
  getActiveNavigationItemName,
} from '../containers/header-navigation';

const getPathBeforeSearch = (state) => {
  const prevMatches = getPreviousMatches(state) || [];
  const actualPrevPath = prevMatches.find(({ pathname }) => !pathname.startsWith('/search')) || {};
  return trim(actualPrevPath.pathname, '/');
};

const removeUnneededParams = (state, parts) => {
  const routeParams = getRouteParams(state);
  const paramsToPop = ['deepLinkData', 'page'];
  paramsToPop.forEach((p) => {
    if (routeParams[p] !== undefined) {
      parts.pop();
    }
  });
};

export const goBack =
  () =>
  async (dispatch, getState, { wixCodeApi }) => {
    const state = getState();
    const categories = getCategories(state);
    const hasOneCategory = categories.length === 1;
    const currentLocation = getLocation(state);

    if (currentLocation.prevPath === '/') {
      const activeTabName = getActiveNavigationItemName(state);

      // TODO: Implement actual go back looking at stack
      return dispatch(
        navigateWithinForum(activeTabName ? `?${createFeedTypeQueryParam(activeTabName)}` : '/'),
      );
    }

    const parts = trim(currentLocation.pathname, '/').split('/');
    parts.pop();

    if (currentLocation.pathname.startsWith('/search/')) {
      parts.splice(-1, 1, getPathBeforeSearch(state));
    } else if (currentLocation.pathname.startsWith('/search')) {
      parts.push(trim(currentLocation.prevPath, '/'));
    }
    removeUnneededParams(state, parts);
    if (hasOneCategory && parts.length === 0) {
      parts.push(categories[0].slug);
    }
    const path = '/' + parts.join('/');

    return dispatch(navigateWithinForum(path));
  };
